import { TOKEN_KEY } from './tokens'
// export const isAuthenticated = () => true; // aqui ta sempre retornadno true pra eu poder testar, mas pode remover depois
export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const login = token => {
  localStorage.setItem(TOKEN_KEY, token);
};
export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
};